import store from "../store/index";
export function interceptRouter(router) {
    router.beforeEach(function (to, from, next) {
        if (!to.matched.some(function (r) { return r.meta.noRequireAuth; })) {
            if (store.getters.user) {
                next();
            }
            else {
                next({
                    path: "/"
                });
            }
            return;
        }
        next();
    });
    return router;
}
